module.exports = __webpack_public_path__ + "img/iteskul.5db9c861.png";